import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api";
import { Status } from "../../../common/constants";
import { editSubscriptionUrl } from "../../../config";
import { RootState } from "../../../store";
import { IEditSubscriptionPayload } from "../../../common/types/dasTypes";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null,
};

interface IEditSubscriptionResponse {
  message: string;
}

const EDIT_SUBSCRIPTION: string = "editSubscription";

export const editSubscription = createAsyncThunk(
  EDIT_SUBSCRIPTION,
  async (payload: IEditSubscriptionPayload, { rejectWithValue }) => {
    try {
      const response = await api.put(
        editSubscriptionUrl + `?subscriptionId=${payload.subscriptionId}`,
        payload.body
      );
      const editSubscriptionResponse: IEditSubscriptionResponse = response.data;
      return editSubscriptionResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const editSubscriptionSlice = createSlice({
  name: EDIT_SUBSCRIPTION,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editSubscription.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(editSubscription.fulfilled, (state) => {
        state.msg = "Subscription Edited Successfully";
        state.status = Status.SUCCESS;
      })
      .addCase(editSubscription.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Error occurred while updating";
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.editSubscriptionApi;

export const reducer = editSubscriptionSlice.reducer;
